// import React, { useContext, useEffect, useRef, useState } from "react";
// import gsap from "gsap";
// import {
//   Modal,
//   Box,
//   Typography,
//   TextField,
//   Button,
//   MenuItem,
//   Alert,
//   Autocomplete,
//   FormControl,
//   Collapse,
//   IconButton,
// } from "@mui/material";
// import { LanguageContext } from "./LanguageContext";
// import CloseIcon from '@mui/icons-material/Close';

// export const ModalContact = ({ open, onClose }) => {
//  const modalRef = useRef(null);
//   const { language } = useContext(LanguageContext);

//   const translations = {
//     en: {
//       title: "Contact Form",
//       name: "Name",
//       email: "Email",
//       country: "Country",
//       phone: "Phone Number",
//       submit: "Submit",
//       errors: {
//         nameRequired: "Name is required",
//         invalidEmail: "Invalid email address",
//         invalidPhone: "Phone number must contain at least 8 digits",
//         submitError: "Error while submitting",
//         submitSuccess: "Submitted successfully ✅",
//         duplicateEmail: "This email is already registered",
//       }
//     },
//     ar: {
//       title: "نموذج التواصل",
//       name: "الاسم",
//       email: "البريد الإلكتروني",
//       country: "الدولة",
//       phone: "رقم الهاتف",
//       submit: "إرسال",
//       errors: {
//         nameRequired: "الاسم مطلوب",
//         invalidEmail: "بريد إلكتروني غير صالح",
//         invalidPhone: "يجب أن يحتوي رقم الهاتف على 8 أرقام على الأقل",
//         submitError: "حدث خطأ أثناء الإرسال",
//         submitSuccess: "تم الإرسال بنجاح ✅",
//         duplicateEmail: "هذا البريد الإلكتروني مسجل بالفعل",
//       }
//     },
//   };

//   const t = translations[language];
//   const [alert, setAlert] = useState({ show: false, message: "", variant: "" });


//   const countries = [
//   { code: 'AD', label: 'Andorra', phone: '376' },
//   {
//     code: 'AE',
//     label: 'United Arab Emirates',
//     phone: '971',
//   },
//   { code: 'AF', label: 'Afghanistan', phone: '93' },
//   {
//     code: 'AG',
//     label: 'Antigua and Barbuda',
//     phone: '1-268',
//   },
//   { code: 'AI', label: 'Anguilla', phone: '1-264' },
//   { code: 'AL', label: 'Albania', phone: '355' },
//   { code: 'AM', label: 'Armenia', phone: '374' },
//   { code: 'AO', label: 'Angola', phone: '244' },
//   { code: 'AQ', label: 'Antarctica', phone: '672' },
//   { code: 'AR', label: 'Argentina', phone: '54' },
//   { code: 'AS', label: 'American Samoa', phone: '1-684' },
//   { code: 'AT', label: 'Austria', phone: '43' },
//   {
//     code: 'AU',
//     label: 'Australia',
//     phone: '61',
//     suggested: true,
//   },
//   { code: 'AW', label: 'Aruba', phone: '297' },
//   { code: 'AX', label: 'Alland Islands', phone: '358' },
//   { code: 'AZ', label: 'Azerbaijan', phone: '994' },
//   {
//     code: 'BA',
//     label: 'Bosnia and Herzegovina',
//     phone: '387',
//   },
//   { code: 'BB', label: 'Barbados', phone: '1-246' },
//   { code: 'BD', label: 'Bangladesh', phone: '880' },
//   { code: 'BE', label: 'Belgium', phone: '32' },
//   { code: 'BF', label: 'Burkina Faso', phone: '226' },
//   { code: 'BG', label: 'Bulgaria', phone: '359' },
//   { code: 'BH', label: 'Bahrain', phone: '973' },
//   { code: 'BI', label: 'Burundi', phone: '257' },
//   { code: 'BJ', label: 'Benin', phone: '229' },
//   { code: 'BL', label: 'Saint Barthelemy', phone: '590' },
//   { code: 'BM', label: 'Bermuda', phone: '1-441' },
//   { code: 'BN', label: 'Brunei Darussalam', phone: '673' },
//   { code: 'BO', label: 'Bolivia', phone: '591' },
//   { code: 'BR', label: 'Brazil', phone: '55' },
//   { code: 'BS', label: 'Bahamas', phone: '1-242' },
//   { code: 'BT', label: 'Bhutan', phone: '975' },
//   { code: 'BV', label: 'Bouvet Island', phone: '47' },
//   { code: 'BW', label: 'Botswana', phone: '267' },
//   { code: 'BY', label: 'Belarus', phone: '375' },
//   { code: 'BZ', label: 'Belize', phone: '501' },
//   {
//     code: 'CA',
//     label: 'Canada',
//     phone: '1',
//     suggested: true,
//   },
//   {
//     code: 'CC',
//     label: 'Cocos (Keeling) Islands',
//     phone: '61',
//   },
//   {
//     code: 'CD',
//     label: 'Congo, Democratic Republic of the',
//     phone: '243',
//   },
//   {
//     code: 'CF',
//     label: 'Central African Republic',
//     phone: '236',
//   },
//   {
//     code: 'CG',
//     label: 'Congo, Republic of the',
//     phone: '242',
//   },
//   { code: 'CH', label: 'Switzerland', phone: '41' },
//   { code: 'CI', label: "Cote d'Ivoire", phone: '225' },
//   { code: 'CK', label: 'Cook Islands', phone: '682' },
//   { code: 'CL', label: 'Chile', phone: '56' },
//   { code: 'CM', label: 'Cameroon', phone: '237' },
//   { code: 'CN', label: 'China', phone: '86' },
//   { code: 'CO', label: 'Colombia', phone: '57' },
//   { code: 'CR', label: 'Costa Rica', phone: '506' },
//   { code: 'CU', label: 'Cuba', phone: '53' },
//   { code: 'CV', label: 'Cape Verde', phone: '238' },
//   { code: 'CW', label: 'Curacao', phone: '599' },
//   { code: 'CX', label: 'Christmas Island', phone: '61' },
//   { code: 'CY', label: 'Cyprus', phone: '357' },
//   { code: 'CZ', label: 'Czech Republic', phone: '420' },
//   {
//     code: 'DE',
//     label: 'Germany',
//     phone: '49',
//     suggested: true,
//   },
//   { code: 'DJ', label: 'Djibouti', phone: '253' },
//   { code: 'DK', label: 'Denmark', phone: '45' },
//   { code: 'DM', label: 'Dominica', phone: '1-767' },
//   {
//     code: 'DO',
//     label: 'Dominican Republic',
//     phone: '1-809',
//   },
//   { code: 'DZ', label: 'Algeria', phone: '213' },
//   { code: 'EC', label: 'Ecuador', phone: '593' },
//   { code: 'EE', label: 'Estonia', phone: '372' },
//   { code: 'EG', label: 'Egypt', phone: '20' },
//   { code: 'EH', label: 'Western Sahara', phone: '212' },
//   { code: 'ER', label: 'Eritrea', phone: '291' },
//   { code: 'ES', label: 'Spain', phone: '34' },
//   { code: 'ET', label: 'Ethiopia', phone: '251' },
//   { code: 'FI', label: 'Finland', phone: '358' },
//   { code: 'FJ', label: 'Fiji', phone: '679' },
//   {
//     code: 'FK',
//     label: 'Falkland Islands (Malvinas)',
//     phone: '500',
//   },
//   {
//     code: 'FM',
//     label: 'Micronesia, Federated States of',
//     phone: '691',
//   },
//   { code: 'FO', label: 'Faroe Islands', phone: '298' },
//   {
//     code: 'FR',
//     label: 'France',
//     phone: '33',
//     suggested: true,
//   },
//   { code: 'GA', label: 'Gabon', phone: '241' },
//   { code: 'GB', label: 'United Kingdom', phone: '44' },
//   { code: 'GD', label: 'Grenada', phone: '1-473' },
//   { code: 'GE', label: 'Georgia', phone: '995' },
//   { code: 'GF', label: 'French Guiana', phone: '594' },
//   { code: 'GG', label: 'Guernsey', phone: '44' },
//   { code: 'GH', label: 'Ghana', phone: '233' },
//   { code: 'GI', label: 'Gibraltar', phone: '350' },
//   { code: 'GL', label: 'Greenland', phone: '299' },
//   { code: 'GM', label: 'Gambia', phone: '220' },
//   { code: 'GN', label: 'Guinea', phone: '224' },
//   { code: 'GP', label: 'Guadeloupe', phone: '590' },
//   { code: 'GQ', label: 'Equatorial Guinea', phone: '240' },
//   { code: 'GR', label: 'Greece', phone: '30' },
//   {
//     code: 'GS',
//     label: 'South Georgia and the South Sandwich Islands',
//     phone: '500',
//   },
//   { code: 'GT', label: 'Guatemala', phone: '502' },
//   { code: 'GU', label: 'Guam', phone: '1-671' },
//   { code: 'GW', label: 'Guinea-Bissau', phone: '245' },
//   { code: 'GY', label: 'Guyana', phone: '592' },
//   { code: 'HK', label: 'Hong Kong', phone: '852' },
//   {
//     code: 'HM',
//     label: 'Heard Island and McDonald Islands',
//     phone: '672',
//   },
//   { code: 'HN', label: 'Honduras', phone: '504' },
//   { code: 'HR', label: 'Croatia', phone: '385' },
//   { code: 'HT', label: 'Haiti', phone: '509' },
//   { code: 'HU', label: 'Hungary', phone: '36' },
//   { code: 'ID', label: 'Indonesia', phone: '62' },
//   { code: 'IE', label: 'Ireland', phone: '353' },
//   { code: 'IL', label: 'Israel', phone: '972' },
//   { code: 'IM', label: 'Isle of Man', phone: '44' },
//   { code: 'IN', label: 'India', phone: '91' },
//   {
//     code: 'IO',
//     label: 'British Indian Ocean Territory',
//     phone: '246',
//   },
//   { code: 'IQ', label: 'Iraq', phone: '964' },
//   {
//     code: 'IR',
//     label: 'Iran, Islamic Republic of',
//     phone: '98',
//   },
//   { code: 'IS', label: 'Iceland', phone: '354' },
//   { code: 'IT', label: 'Italy', phone: '39' },
//   { code: 'JE', label: 'Jersey', phone: '44' },
//   { code: 'JM', label: 'Jamaica', phone: '1-876' },
//   { code: 'JO', label: 'Jordan', phone: '962' },
//   {
//     code: 'JP',
//     label: 'Japan',
//     phone: '81',
//     suggested: true,
//   },
//   { code: 'KE', label: 'Kenya', phone: '254' },
//   { code: 'KG', label: 'Kyrgyzstan', phone: '996' },
//   { code: 'KH', label: 'Cambodia', phone: '855' },
//   { code: 'KI', label: 'Kiribati', phone: '686' },
//   { code: 'KM', label: 'Comoros', phone: '269' },
//   {
//     code: 'KN',
//     label: 'Saint Kitts and Nevis',
//     phone: '1-869',
//   },
//   {
//     code: 'KP',
//     label: "Korea, Democratic People's Republic of",
//     phone: '850',
//   },
//   { code: 'KR', label: 'Korea, Republic of', phone: '82' },
//   { code: 'KW', label: 'Kuwait', phone: '965' },
//   { code: 'KY', label: 'Cayman Islands', phone: '1-345' },
//   { code: 'KZ', label: 'Kazakhstan', phone: '7' },
//   {
//     code: 'LA',
//     label: "Lao People's Democratic Republic",
//     phone: '856',
//   },
//   { code: 'LB', label: 'Lebanon', phone: '961' },
//   { code: 'LC', label: 'Saint Lucia', phone: '1-758' },
//   { code: 'LI', label: 'Liechtenstein', phone: '423' },
//   { code: 'LK', label: 'Sri Lanka', phone: '94' },
//   { code: 'LR', label: 'Liberia', phone: '231' },
//   { code: 'LS', label: 'Lesotho', phone: '266' },
//   { code: 'LT', label: 'Lithuania', phone: '370' },
//   { code: 'LU', label: 'Luxembourg', phone: '352' },
//   { code: 'LV', label: 'Latvia', phone: '371' },
//   { code: 'LY', label: 'Libya', phone: '218' },
//   { code: 'MA', label: 'Morocco', phone: '212' },
//   { code: 'MC', label: 'Monaco', phone: '377' },
//   {
//     code: 'MD',
//     label: 'Moldova, Republic of',
//     phone: '373',
//   },
//   { code: 'ME', label: 'Montenegro', phone: '382' },
//   {
//     code: 'MF',
//     label: 'Saint Martin (French part)',
//     phone: '590',
//   },
//   { code: 'MG', label: 'Madagascar', phone: '261' },
//   { code: 'MH', label: 'Marshall Islands', phone: '692' },
//   {
//     code: 'MK',
//     label: 'Macedonia, the Former Yugoslav Republic of',
//     phone: '389',
//   },
//   { code: 'ML', label: 'Mali', phone: '223' },
//   { code: 'MM', label: 'Myanmar', phone: '95' },
//   { code: 'MN', label: 'Mongolia', phone: '976' },
//   { code: 'MO', label: 'Macao', phone: '853' },
//   {
//     code: 'MP',
//     label: 'Northern Mariana Islands',
//     phone: '1-670',
//   },
//   { code: 'MQ', label: 'Martinique', phone: '596' },
//   { code: 'MR', label: 'Mauritania', phone: '222' },
//   { code: 'MS', label: 'Montserrat', phone: '1-664' },
//   { code: 'MT', label: 'Malta', phone: '356' },
//   { code: 'MU', label: 'Mauritius', phone: '230' },
//   { code: 'MV', label: 'Maldives', phone: '960' },
//   { code: 'MW', label: 'Malawi', phone: '265' },
//   { code: 'MX', label: 'Mexico', phone: '52' },
//   { code: 'MY', label: 'Malaysia', phone: '60' },
//   { code: 'MZ', label: 'Mozambique', phone: '258' },
//   { code: 'NA', label: 'Namibia', phone: '264' },
//   { code: 'NC', label: 'New Caledonia', phone: '687' },
//   { code: 'NE', label: 'Niger', phone: '227' },
//   { code: 'NF', label: 'Norfolk Island', phone: '672' },
//   { code: 'NG', label: 'Nigeria', phone: '234' },
//   { code: 'NI', label: 'Nicaragua', phone: '505' },
//   { code: 'NL', label: 'Netherlands', phone: '31' },
//   { code: 'NO', label: 'Norway', phone: '47' },
//   { code: 'NP', label: 'Nepal', phone: '977' },
//   { code: 'NR', label: 'Nauru', phone: '674' },
//   { code: 'NU', label: 'Niue', phone: '683' },
//   { code: 'NZ', label: 'New Zealand', phone: '64' },
//   { code: 'OM', label: 'Oman', phone: '968' },
//   { code: 'PA', label: 'Panama', phone: '507' },
//   { code: 'PE', label: 'Peru', phone: '51' },
//   { code: 'PF', label: 'French Polynesia', phone: '689' },
//   { code: 'PG', label: 'Papua New Guinea', phone: '675' },
//   { code: 'PH', label: 'Philippines', phone: '63' },
//   { code: 'PK', label: 'Pakistan', phone: '92' },
//   { code: 'PL', label: 'Poland', phone: '48' },
//   {
//     code: 'PM',
//     label: 'Saint Pierre and Miquelon',
//     phone: '508',
//   },
//   { code: 'PN', label: 'Pitcairn', phone: '870' },
//   { code: 'PR', label: 'Puerto Rico', phone: '1' },
//   {
//     code: 'PS',
//     label: 'Palestine, State of',
//     phone: '970',
//   },
//   { code: 'PT', label: 'Portugal', phone: '351' },
//   { code: 'PW', label: 'Palau', phone: '680' },
//   { code: 'PY', label: 'Paraguay', phone: '595' },
//   { code: 'QA', label: 'Qatar', phone: '974' },
//   { code: 'RE', label: 'Reunion', phone: '262' },
//   { code: 'RO', label: 'Romania', phone: '40' },
//   { code: 'RS', label: 'Serbia', phone: '381' },
//   { code: 'RU', label: 'Russian Federation', phone: '7' },
//   { code: 'RW', label: 'Rwanda', phone: '250' },
//   { code: 'SA', label: 'Saudi Arabia', phone: '966' },
//   { code: 'SB', label: 'Solomon Islands', phone: '677' },
//   { code: 'SC', label: 'Seychelles', phone: '248' },
//   { code: 'SD', label: 'Sudan', phone: '249' },
//   { code: 'SE', label: 'Sweden', phone: '46' },
//   { code: 'SG', label: 'Singapore', phone: '65' },
//   { code: 'SH', label: 'Saint Helena', phone: '290' },
//   { code: 'SI', label: 'Slovenia', phone: '386' },
//   {
//     code: 'SJ',
//     label: 'Svalbard and Jan Mayen',
//     phone: '47',
//   },
//   { code: 'SK', label: 'Slovakia', phone: '421' },
//   { code: 'SL', label: 'Sierra Leone', phone: '232' },
//   { code: 'SM', label: 'San Marino', phone: '378' },
//   { code: 'SN', label: 'Senegal', phone: '221' },
//   { code: 'SO', label: 'Somalia', phone: '252' },
//   { code: 'SR', label: 'Suriname', phone: '597' },
//   { code: 'SS', label: 'South Sudan', phone: '211' },
//   {
//     code: 'ST',
//     label: 'Sao Tome and Principe',
//     phone: '239',
//   },
//   { code: 'SV', label: 'El Salvador', phone: '503' },
//   {
//     code: 'SX',
//     label: 'Sint Maarten (Dutch part)',
//     phone: '1-721',
//   },
//   {
//     code: 'SY',
//     label: 'Syrian Arab Republic',
//     phone: '963',
//   },
//   { code: 'SZ', label: 'Swaziland', phone: '268' },
//   {
//     code: 'TC',
//     label: 'Turks and Caicos Islands',
//     phone: '1-649',
//   },
//   { code: 'TD', label: 'Chad', phone: '235' },
//   {
//     code: 'TF',
//     label: 'French Southern Territories',
//     phone: '262',
//   },
//   { code: 'TG', label: 'Togo', phone: '228' },
//   { code: 'TH', label: 'Thailand', phone: '66' },
//   { code: 'TJ', label: 'Tajikistan', phone: '992' },
//   { code: 'TK', label: 'Tokelau', phone: '690' },
//   { code: 'TL', label: 'Timor-Leste', phone: '670' },
//   { code: 'TM', label: 'Turkmenistan', phone: '993' },
//   { code: 'TN', label: 'Tunisia', phone: '216' },
//   { code: 'TO', label: 'Tonga', phone: '676' },
//   { code: 'TR', label: 'Turkey', phone: '90' },
//   {
//     code: 'TT',
//     label: 'Trinidad and Tobago',
//     phone: '1-868',
//   },
//   { code: 'TV', label: 'Tuvalu', phone: '688' },
//   {
//     code: 'TW',
//     label: 'Taiwan',
//     phone: '886',
//   },
//   {
//     code: 'TZ',
//     label: 'United Republic of Tanzania',
//     phone: '255',
//   },
//   { code: 'UA', label: 'Ukraine', phone: '380' },
//   { code: 'UG', label: 'Uganda', phone: '256' },
//   {
//     code: 'US',
//     label: 'United States',
//     phone: '1',
//     suggested: true,
//   },
//   { code: 'UY', label: 'Uruguay', phone: '598' },
//   { code: 'UZ', label: 'Uzbekistan', phone: '998' },
//   {
//     code: 'VA',
//     label: 'Holy See (Vatican City State)',
//     phone: '379',
//   },
//   {
//     code: 'VC',
//     label: 'Saint Vincent and the Grenadines',
//     phone: '1-784',
//   },
//   { code: 'VE', label: 'Venezuela', phone: '58' },
//   {
//     code: 'VG',
//     label: 'British Virgin Islands',
//     phone: '1-284',
//   },
//   {
//     code: 'VI',
//     label: 'US Virgin Islands',
//     phone: '1-340',
//   },
//   { code: 'VN', label: 'Vietnam', phone: '84' },
//   { code: 'VU', label: 'Vanuatu', phone: '678' },
//   { code: 'WF', label: 'Wallis and Futuna', phone: '681' },
//   { code: 'WS', label: 'Samoa', phone: '685' },
//   { code: 'XK', label: 'Kosovo', phone: '383' },
//   { code: 'YE', label: 'Yemen', phone: '967' },
//   { code: 'YT', label: 'Mayotte', phone: '262' },
//   { code: 'ZA', label: 'South Africa', phone: '27' },
//   { code: 'ZM', label: 'Zambia', phone: '260' },
//   { code: 'ZW', label: 'Zimbabwe', phone: '263' },
// ];
//   const [country, setCountry] = useState(countries.find(c => c.code === 'AE'));
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "+971",
//   });

//   const handleCountryChange = (_, selectedCountry) => {
//     if (selectedCountry) {
//       setCountry(selectedCountry);
//       setFormData(prev => ({
//         ...prev,
//         phone: `+${selectedCountry.phone}`
//       }));
//     }
//   };

//   const handleChange = (field) => (e) => {
//     setFormData(prev => ({ ...prev, [field]: e.target.value }));
//   };

//   const handlePhoneChange = (e) => {
//     const inputValue = e.target.value;
//     const countryCode = country ? `+${country.phone}` : "";
    
//     if (!inputValue.startsWith(countryCode)) {
//       setFormData(prev => ({
//         ...prev,
//         phone: countryCode + inputValue.replace(/^\+\d+/, '')
//       }));
//     } else {
//       setFormData(prev => ({
//         ...prev,
//         phone: inputValue
//       }));
//     }
//   };

//   const handleSubmit = async () => {
//     // التحقق من الصحة
//     if (!formData.name.trim()) {
//       setAlert({ show: true, message: t.errors.nameRequired, variant: "danger" });
//       return;
//     }
    
//     if (!formData.email.trim() || !/\S+@\S+\.\S+/.test(formData.email)) {
//       setAlert({ show: true, message: t.errors.invalidEmail, variant: "danger" });
//       return;
//     }
    
//     const phoneDigits = formData.phone.replace(/[^0-9]/g, '');
//     if (phoneDigits.length < 8) {
//       setAlert({ show: true, message: t.errors.invalidPhone, variant: "danger" });
//       return;
//     }

//     // إعداد البيانات للإرسال
//     const payload = {
//       name: formData.name,
//       // email: formData.email,
//       // country: country?.label || "United Arab Emirates",
//       // phone: formData.phone,
//     };

//     try {
//       const response = await fetch("https://apirender8.onrender.com/api/v1/communicationway", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || response.statusText);
//       }

//       setAlert({ 
//         show: true, 
//         message: t.errors.submitSuccess, 
//         variant: "success" 
//       });

//       // إعادة تعيين النموذج بعد 2 ثانية
//       setTimeout(() => {
//         setFormData({
//           name: "",
//           email: "",
//           phone: country ? `+${country.phone}` : "+971",
//         });
//         handleClose();
//       }, 2000);

//     } catch (error) {
//       console.error("Submission error:", error);
      
//       let errorMessage = t.errors.submitError;
//       if (error.message.includes("409") || error.message.toLowerCase().includes("duplicate")) {
//         errorMessage = t.errors.duplicateEmail;
//       }

//       setAlert({ 
//         show: true, 
//         message: errorMessage, 
//         variant: "danger" 
//       });
//     }
//   };

//   useEffect(() => {
//     if (alert.show) {
//       const timer = setTimeout(() => {
//         setAlert(prev => ({ ...prev, show: false }));
//       }, 5000);
//       return () => clearTimeout(timer);
//     }
//   }, [alert]);
//   const handleClose = () => {
//     if (!modalRef.current) return;

//     const modal = modalRef.current;
//     const children = modal.querySelectorAll("h6, input, select, button");

//     const tl = gsap.timeline({
//       onComplete: () => onClose && onClose(),
//     });

//     tl.to(children, {
//       opacity: 0,
//       y: 20,
//       duration: 0.25,
//       stagger: 0.05,
//       ease: "power1.in",
//     }).to(modal, { opacity: 0, scale: 0.95, duration: 0.3, ease: "power1.in" }, "-=0.1");
//   };

//   useEffect(() => {
//     if (!open || !modalRef.current) return;

//     const modal = modalRef.current;
//     const children = modal.querySelectorAll("h6, input, select, button");

//     const tl = gsap.timeline();
//     tl.fromTo(
//       modal,
//       { opacity: 0, scale: 0.95 },
//       { opacity: 1, scale: 1, duration: 0.4, ease: "power1.out" }
//     ).fromTo(
//       children,
//       { opacity: 0, y: 20 },
//       { opacity: 1, y: 0, duration: 0.35, stagger: 0.1, ease: "power1.out" },
//       "-=0.2"
//     );
//   }, [open]);

//   return (
//     <Modal open={open} onClose={handleClose}>
//       <Box
//         ref={modalRef}
//         sx={{
//           backgroundColor: "white",
//           padding: 3,
//           borderRadius: 2,
//           width: 400,
//           mx: "auto",
//           mt: "10%",
//           boxShadow: 24,
//           position: 'relative',
//         }}
//       >
 

//         <Typography variant="h6" gutterBottom>
//           {t.title}
//         </Typography>



//         {/* Alert يظهر هنا تحت العنوان مباشرة */}
//         <Collapse in={alert.show}>
//           <Alert
//             severity={alert.variant}
//             action={
//               <IconButton
//                 aria-label="close"
//                 color="inherit"
//                 size="small"
//                 onClick={() => {
//                   setAlert({ ...alert, show: false });
//                 }}
//               >
//                 <CloseIcon fontSize="inherit" />
//               </IconButton>
//             }
//             sx={{ mb: 2 }}
//           >
//             {alert.message}
//           </Alert>
//         </Collapse>


//         <TextField
//           fullWidth
//           label={t.name}
//           value={formData.name}
//           onChange={handleChange("name")}
//           margin="normal"
//         />

//         <TextField
//           fullWidth
//           label={t.email}
//           type="email"
//           value={formData.email}
//           onChange={handleChange("email")}
//           margin="normal"
//         />

//         <FormControl fullWidth sx={{ mt: 2 }}>
//           <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
//             <Autocomplete
//               options={countries}
//               value={country}
//               onChange={handleCountryChange}
//               getOptionLabel={(option) => option.label}
//               renderOption={(props, option) => (
//                 <Box component="li" {...props} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                   <img
//                     loading="lazy"
//                     width="20"
//                     src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
//                     srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
//                     alt=""
//                   />
//                   {option.label} (+{option.phone})
//                 </Box>
//               )}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   label={t.country}
//                   placeholder="Select"
//                   variant="outlined"
//                   InputProps={{
//                     ...params.InputProps,
//                     sx: {
//                       minWidth: '120px',
//                       height: '48px',
//                       fontSize: '14px',
//                     }
//                   }}
//                 />
//               )}
//               sx={{ minWidth: 120 }}
//             />

//             <TextField
//               label={t.phone}
//               type="tel"
//               value={formData.phone}
//               onChange={handlePhoneChange}
//               fullWidth
//               variant="outlined"
//               InputProps={{
//                 sx: {
//                   fontSize: '16px',
//                   height: '48px',
//                 }
//               }}
//             />
//           </Box>
//         </FormControl>

//         <Button
//           variant="contained"
//           color="success"
//           fullWidth
//           sx={{ mt: 3 }}
//           onClick={handleSubmit}
//         >
//           {t.submit}
//         </Button>
//       </Box>
//     </Modal>
//   );
// };
























import React, { useContext, useRef, useState, useEffect } from "react";
import {
  Modal, Box, TextField, Button, FormControl,
  Autocomplete, IconButton, Collapse,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LanguageContext } from "./LanguageContext";

const countries = [
  { code: "AE", label: "United Arab Emirates", phone: "971" },
  { code: "SA", label: "Saudi Arabia",          phone: "966" },
  { code: "KW", label: "Kuwait",                phone: "965" },
  { code: "QA", label: "Qatar",                 phone: "974" },
  { code: "BH", label: "Bahrain",               phone: "973" },
  { code: "OM", label: "Oman",                  phone: "968" },
  { code: "EG", label: "Egypt",                 phone: "20"  },
  { code: "JO", label: "Jordan",                phone: "962" },
  { code: "LB", label: "Lebanon",               phone: "961" },
  { code: "IQ", label: "Iraq",                  phone: "964" },
  { code: "SY", label: "Syria",                 phone: "963" },
  { code: "YE", label: "Yemen",                 phone: "967" },
  { code: "MA", label: "Morocco",               phone: "212" },
  { code: "TN", label: "Tunisia",               phone: "216" },
  { code: "DZ", label: "Algeria",               phone: "213" },
  { code: "GB", label: "United Kingdom",        phone: "44"  },
  { code: "US", label: "United States",         phone: "1"   },
  { code: "FR", label: "France",                phone: "33"  },
  { code: "DE", label: "Germany",               phone: "49"  },
  { code: "IN", label: "India",                 phone: "91"  },
  { code: "PK", label: "Pakistan",              phone: "92"  },
  { code: "RU", label: "Russian Federation",    phone: "7"   },
  { code: "CN", label: "China",                 phone: "86"  },
  { code: "AU", label: "Australia",             phone: "61"  },
  { code: "CA", label: "Canada",                phone: "1"   },
];

const DEFAULT_COUNTRY = countries[0];

// ✅ نفس الـ API URL
const API_URL =
  "https://homewalkers.realatixcrm.com/api/v1/users/create-with-params" +
  "?addedby=68da45a5b37ddfab3b73bd8b" +
  "&stage=68d110bbad5a0732ad44e5cf" +
  "&Channal=6a48bfa6a4cf5854ad69d511" +
  "&project=68e36f383b0e6ff7d205ded6" +
  "&salesdata=68da75b5b37ddfab3b7463f5" +
  "&Communicationway=69159308820816f4ad71c3bf" +
  "&campaignid=69ca62736bc129db99a826fb" +
  "&includePhone2=false" +
  "&includeWhatsapp=false" +
  "&includeJobDesc=false" +
  "&includeQuestion1=false" +
  "&includeQuestion2=false" +
  "&includeQuestion3=false" +
  "&includeQuestion4=false" +
  "&includeQuestion5=false" +
  "&campaignRedirectLink=https%3A%2F%2Fmassar3-d09ef.web.app%2F";

// ✅ نفس الـ validation
const validate = (formData, t) => {
  const { name, email, country, phone } = formData;

  if (!name.trim())
    return t.errName;
  if (name.trim().length < 2)
    return t.errNameShort;
  if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
    return t.errEmail;
  if (!country)
    return t.errCountry;

  const codeStr    = `+${country.phone}`;
  const digitsOnly = phone.replace(codeStr, "").replace(/\D/g, "");
  if (!phone || phone === codeStr)
    return t.errPhoneRequired;
  if (digitsOnly.length < 7)
    return t.errPhone;
  if (digitsOnly.length > 12)
    return t.errPhoneLong;

  return null;
};

const fieldSx = (isArabic) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    fontFamily:   "'Cairo', sans-serif",
    "& fieldset":             { borderColor: "rgba(74,124,63,0.25)" },
    "&:hover fieldset":       { borderColor: "rgba(74,124,63,0.5)"  },
    "&.Mui-focused fieldset": { borderColor: "#4a7c3f", borderWidth: "1.5px" },
  },
  "& .MuiInputLabel-root": {
    fontFamily: "'Cairo', sans-serif",
    color:      "#4a5a4a",
    "&.Mui-focused": { color: "#4a7c3f" },
    ...(isArabic ? { right: 14, left: "auto", transformOrigin: "right" } : {}),
  },
  "& input": { fontFamily: "'Cairo', sans-serif", color: "#0f1f0f" },
});

export const ModalContact = ({ open, onClose }) => {
  const { language } = useContext(LanguageContext);
  const isArabic = language === "ar";

  const [formData, setFormData] = useState({
    name:    "",
    email:   "",
    country: DEFAULT_COUNTRY,
    phone:   `+${DEFAULT_COUNTRY.phone}`,
  });

  const [alert,   setAlert]   = useState({ show: false, message: "", ok: false });
  const [loading, setLoading] = useState(false);

  const t = {
    en: {
      title:           "Request More Info",
      sub:             "Fill in your details and we'll reach out soon",
      name:            "Full Name *",
      email:           "Email Address *",
      country:         "Country *",
      phone:           "Phone Number *",
      submit:          "Send Request",
      submitting:      "Sending...",
      success:         "Submitted successfully ✅",
      errName:         "Name is required",
      errNameShort:    "Name must be at least 2 characters",
      errEmail:        "Invalid email address",
      errCountry:      "Please select a country",
      errPhoneRequired:"Phone number is required",
      errPhone:        "Phone must be at least 7 digits",
      errPhoneLong:    "Phone number is too long",
      errDup:          "Email already registered",
      errBadData:      "Invalid data, please review",
      errGen:          "Submission error, please try again",
    },
    ar: {
      title:           "طلب مزيد من المعلومات",
      sub:             "أدخل بياناتك وسنتواصل معك قريباً",
      name:            "الاسم الكامل *",
      email:           "البريد الإلكتروني *",
      country:         "الدولة *",
      phone:           "رقم الهاتف *",
      submit:          "إرسال الطلب",
      submitting:      "جاري الإرسال...",
      success:         "تم الإرسال بنجاح ✅",
      errName:         "الاسم مطلوب",
      errNameShort:    "الاسم يجب أن يكون حرفين على الأقل",
      errEmail:        "بريد إلكتروني غير صالح",
      errCountry:      "يرجى اختيار الدولة",
      errPhoneRequired:"رقم الهاتف مطلوب",
      errPhone:        "يجب أن يحتوي الرقم على 7 أرقام على الأقل",
      errPhoneLong:    "رقم الهاتف طويل جداً",
      errDup:          "البريد الإلكتروني مسجّل مسبقاً",
      errBadData:      "بيانات غير صحيحة، يرجى المراجعة",
      errGen:          "حدث خطأ، يرجى المحاولة مجدداً",
    },
  }[language];

  // ── Reset لما الـ modal يتقفل ──
  useEffect(() => {
    if (!open) {
      setTimeout(() => {
        setFormData({ name: "", email: "", country: DEFAULT_COUNTRY, phone: `+${DEFAULT_COUNTRY.phone}` });
        setAlert({ show: false, message: "", ok: false });
        setLoading(false);
      }, 300);
    }
  }, [open]);

  // ── Auto-hide alert ──
  useEffect(() => {
    if (!alert.show) return;
    const timer = setTimeout(() => setAlert((p) => ({ ...p, show: false })), 5000);
    return () => clearTimeout(timer);
  }, [alert.show]);

  const handleCountryChange = (_, val) => {
    const c = val || DEFAULT_COUNTRY;
    setFormData((p) => ({ ...p, country: c, phone: `+${c.phone}` }));
  };

  const handlePhoneChange = (e) => {
    const code = `+${formData.country.phone}`;
    const val  = e.target.value;
    setFormData((p) => ({
      ...p,
      phone: val.startsWith(code) ? val : code + val.replace(/^\+\d+/, ""),
    }));
  };

 const handleSubmit = async () => {
  const { name, email, country, phone } = formData;

  // ✅ الدولة لازم تتاختار
  if (!country)
    return setAlert({ show: true, message: t.errCountry, ok: false });

  // ✅ الهاتف لازم يتملا
  const codeStr    = `+${country.phone}`;
  const digitsOnly = phone.replace(codeStr, "").replace(/\D/g, "");
  if (!phone || phone === codeStr)
    return setAlert({ show: true, message: t.errPhoneRequired, ok: false });
  if (digitsOnly.length < 7)
    return setAlert({ show: true, message: t.errPhone, ok: false });
  if (digitsOnly.length > 12)
    return setAlert({ show: true, message: t.errPhoneLong, ok: false });

  setLoading(true);
  setAlert({ show: false, message: "", ok: false });

  try {
    const res = await fetch(API_URL, {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        // ✅ لو الاسم فاضي نحط "no name"
        name:    name.trim() || "no name",
        // ✅ الإيميل بنبعته زي ما هو بدون validate
        email:   email.trim().toLowerCase() || "",
        country: country.label,
        phone:   phone,
      }),
    });

    if (!res.ok) throw new Error(`${res.status}`);

    setAlert({ show: true, message: t.success, ok: true });

    setTimeout(() => {
      setFormData({ name: "", email: "", country: DEFAULT_COUNTRY, phone: `+${DEFAULT_COUNTRY.phone}` });
      setAlert({ show: false, message: "", ok: false });
      onClose?.();
    }, 2000);

  } catch (err) {
    const status = err.message;
    setAlert({
      show: true,
      ok:   false,
      message:
        status.includes("409") ? t.errDup
      : status.includes("400") ? t.errBadData
      : t.errGen,
    });
  } finally {
    setLoading(false);
  }
};
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        dir={isArabic ? "rtl" : "ltr"}
        sx={{
          position:  "absolute",
          top:       "50%",
          left:      "50%",
          transform: "translate(-50%, -50%)",
          width:     { xs: "92vw", sm: "480px" },
          maxHeight: "90vh",
          overflowY: "auto",
          outline:   "none",
          background:   "#fff",
          borderRadius: "24px",
          boxShadow:    "0 32px 80px rgba(0,0,0,0.2)",
          fontFamily:   "'Cairo', sans-serif",
        }}
      >
        {/* ── Green header ── */}
        <Box sx={{
          background:   "linear-gradient(135deg, #3d6b34, #6aad55)",
          borderRadius: "24px 24px 0 0",
          padding:      "28px 28px 24px",
          position:     "relative",
        }}>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              position: "absolute",
              top: 14, [isArabic ? "left" : "right"]: 14,
              color: "rgba(255,255,255,0.8)",
              "&:hover": { color: "#fff", background: "rgba(255,255,255,0.15)" },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          <Box sx={{
            display: "inline-block",
            background: "rgba(255,255,255,0.18)",
            borderRadius: "20px",
            px: 1.5, py: 0.4,
            fontSize: "0.7rem", fontWeight: 700,
            letterSpacing: "0.15em", textTransform: "uppercase",
            color: "rgba(255,255,255,0.9)", mb: 1,
            fontFamily: "'Cairo', sans-serif",
          }}>
            🌿 {isArabic ? "مسار — الشارقة" : "Masar — Sharjah"}
          </Box>

          <Box component="h2" sx={{
            m: 0, color: "#fff",
            fontFamily: "'Cairo', sans-serif",
            fontWeight: 900,
            fontSize: { xs: "1.3rem", sm: "1.55rem" },
            lineHeight: 1.2,
          }}>
            {t.title}
          </Box>

          <Box component="p" sx={{
            m: 0, mt: 0.5,
            color: "rgba(255,255,255,0.75)",
            fontFamily: "'Cairo', sans-serif",
            fontSize: "0.85rem",
          }}>
            {t.sub}
          </Box>
        </Box>

        {/* ── Form body ── */}
        <Box sx={{
          padding:       "24px 28px 28px",
          display:       "flex",
          flexDirection: "column",
          gap:           "14px",
        }}>
          {/* Alert */}
          <Collapse in={alert.show}>
            <Box sx={{
              display:        "flex",
              alignItems:     "center",
              justifyContent: "space-between",
              gap:      1,
              background: alert.ok ? "rgba(74,124,63,0.1)" : "rgba(200,50,50,0.08)",
              border:    `1px solid ${alert.ok ? "rgba(74,124,63,0.3)" : "rgba(200,50,50,0.25)"}`,
              borderRadius: "10px",
              padding:      "10px 14px",
              fontFamily:   "'Cairo', sans-serif",
              fontSize:     "0.88rem",
              color:        alert.ok ? "#2e5e26" : "#9b2020",
            }}>
              <span>{alert.message}</span>
              <IconButton
                size="small"
                onClick={() => setAlert((p) => ({ ...p, show: false }))}
                sx={{ color: "inherit", p: 0.3 }}
              >
                <CloseIcon sx={{ fontSize: "1rem" }} />
              </IconButton>
            </Box>
          </Collapse>

          {/* Name */}
          <TextField
            label={t.name} fullWidth size="small"
            value={formData.name}
            onChange={(e) => setFormData((p) => ({ ...p, name: e.target.value }))}
            inputProps={{ dir: isArabic ? "rtl" : "ltr" }}
            sx={fieldSx(isArabic)}
          />

          {/* Email */}
          <TextField
            label={t.email} type="email" fullWidth size="small"
            value={formData.email}
            onChange={(e) => setFormData((p) => ({ ...p, email: e.target.value }))}
            inputProps={{ dir: "ltr" }}
            sx={fieldSx(isArabic)}
          />

          {/* Country + Phone */}
          <FormControl fullWidth>
            <Box sx={{ display: "flex", gap: 1, flexDirection: { xs: "column", sm: "row" } }}>
              <Autocomplete
                options={countries}
                value={formData.country}
                onChange={handleCountryChange}
                getOptionLabel={(o) => o.label}
                renderOption={(props, option) => (
                  <Box component="li" {...props}
                    sx={{ display: "flex", alignItems: "center", gap: 1,
                      fontFamily: "'Cairo', sans-serif", fontSize: "0.88rem" }}>
                    <img loading="lazy" width="18"
                      src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                      srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                      alt=""
                    />
                    {option.label} (+{option.phone})
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} label={t.country} size="small" sx={fieldSx(isArabic)} />
                )}
                sx={{
                  flex: 1.3,
                  "& .MuiAutocomplete-popupIndicator, & .MuiAutocomplete-clearIndicator": {
                    color: "#4a7c3f",
                  },
                }}
              />
              <TextField
                label={t.phone} type="tel" size="small"
                value={formData.phone}
                onChange={handlePhoneChange}
                inputProps={{ dir: "ltr" }}
                sx={{ ...fieldSx(isArabic), flex: 1 }}
              />
            </Box>
          </FormControl>

          {/* Submit */}
          <Button
            fullWidth
            onClick={handleSubmit}
            disabled={loading}
            sx={{
              mt:           0.5,
              height:       "48px",
              borderRadius: "14px",
              fontFamily:   "'Cairo', sans-serif",
              fontWeight:   700,
              fontSize:     "0.97rem",
              textTransform:"none",
              background:   loading
                              ? "rgba(74,124,63,0.5)"
                              : "linear-gradient(135deg, #4a7c3f, #6aad55)",
              color:        "#fff",
              boxShadow:    "0 6px 20px rgba(74,124,63,0.35)",
              transition:   "all 0.25s ease",
              "&:hover": {
                background: "linear-gradient(135deg, #3d6b34, #5a9a47)",
                boxShadow:  "0 10px 28px rgba(74,124,63,0.45)",
                transform:  "translateY(-2px)",
              },
            }}
          >
            {loading ? t.submitting : t.submit}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};